import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import servicii from "../images/servicii-img.png";
import smallServicii from "../images/small-servicii.png";
import "../css/main.css";

const EvaluareCopii = () => {
  return (
    <div>
      <Header />

      <div className="contributii blog servicii serviciu-page">
        <div className="container">
          <div className="info-section text-b">AWARE</div>
          <h1 className="text-b">Evaluarea copilului și adolescentului</h1>
          <p>
            In evaluarea psihologica a copilului si adolescentului tinem cont de
            particularitatile acestui proces:
          </p>
          <ul>
            <li>
              1. Implicarea parintelui/ingrijitorului in procesul de evaluare si
              consiliere psihologica <br></br> - motivul pentru care parintele
              solicita evaluarea <br></br>- balanta dintre asteptarile
              parintelui si disponibilitatea copilului
            </li>
            <li>
              Contextele care sunt implicate : familie, scoala, comunitatea
            </li>
            <li>
              Factorii relationati cu dezvoltarea copilului/ adolescentului{" "}
              <br></br>- etapa si nivelul de dezvoltare <br></br>-
              particularitatile contextului de viata al copilului <br></br>
              -adaptarea metodei de evaluare la etapa de dezvoltare a
              copilului/adolescentului: observatie (copilaria mica), joc
              (prescolari) interviu si alte instrumente (scolari si adolescenti)
            </li>
          </ul>
          <p>
            In cadrul Centrului de psiho Aware ne responsabilizam prin procesul
            de evaluare psihologica in a aaduce o cat mai buna intelegere asupra
            particularitatilor psihologice ale copilului/adolescentului.
          </p>

          <p>
            Prin filtrul orientarii umaniste cautam, plecand de la scale si
            instrumente de evaluare, sa privim dincolo de acestea, catre unicul
            si particularul fiecarui copil/adolescent, identificand
            particularitatile, abilitatile dar si provocarile cu care se
            confrunta.
          </p>
          <p>
            Pentru evaluarea copilului si adolescentului, pe lamga observatii si
            interviul clinic, utilizam baterii de instrumente complexe care
            acopera o plaja larga de nevoi:
          </p>
          <ul>
            <li>instrumente de evaluare neuropsihologica</li>
            <li>instrumente de evaluare a nivelului de dezvoltare </li>
            <li>instrumente de evaluare a comportamentului</li>
            <li>instrumente de evaluare a aptitudinilor si abilitatilor</li>
            <li>
              instrumente de evaluare socio-emotionale si a abilitatilor de
              relationare
            </li>
            <li>instrumente de evaluare a nivelului de adaptare</li>
            <li>instrumente de evaluare a personalitatii</li>
            <li>
              instrumente de evaluare a nivelului de pregatire de pregatire
              pentru scoala – prescolari
            </li>
            <li>instrumente de evaluare a dizabilitatii</li>
          </ul>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EvaluareCopii;
